import { performRequest } from 'common/utils/performRequest';

export const GET_AUGMENTED_GUESTROOMS_REQUEST =
  'GET_AUGMENTED_GUESTROOMS_REQUEST';
export const GET_AUGMENTED_GUESTROOMS_SUCCESS =
  'GET_AUGMENTED_GUESTROOMS_SUCCESS';
export const GET_AUGMENTED_GUESTROOMS_FAILURE =
  'GET_AUGMENTED_GUESTROOMS_FAILURE';

export default function getAugmentedGuestrooms(brand, pid, values = {}) {
  return async dispatch => {
    dispatch({
      type: GET_AUGMENTED_GUESTROOMS_REQUEST,
    });

    try {
      const header = { action: 'RETRIEVE_ADDL' };
      const { data } = await performRequest(
        'get',
        `/api/content/dashboard/property-details/${brand}/${pid}/en`,
        header
      );

      // const { guestRooms = [] } = values;
      // const updatedGuestRooms = data.prop.guestRooms.map((room, index) => ({
      //   ...room,
      //   show: guestRooms[index]?.show,
      // }));

      // const formData = {
      //   ...data.prop,
      //   guestRooms: updatedGuestRooms,
      // };

      dispatch({
        type: GET_AUGMENTED_GUESTROOMS_SUCCESS,
        payload: data.prop?.guestRooms,
      });
    } catch (error) {
      dispatch({
        type: GET_AUGMENTED_GUESTROOMS_FAILURE,
        payload: error.response.data,
      });
    }
  };
}
